export default __webpack_public_path__ + "static/media/THEME (dark).3fc1b9c2.png";